import React, { useEffect } from 'react';
import { toast, dismissToast } from '../widgets/alerts/Toast';

/* Utilidades compartidas por los módulos de auditoría de ingresos (auditoriaIngresosGlobal e ingresosUsuarios). */

export const formatDateTime = (dateStr, vacio = null) => {
  if (!dateStr) return vacio;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return String(dateStr);
  return d.toLocaleString('es-CO', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
};

const toDateInputValue = (d) => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getPresetDates = (days) => {
  if (days === null || days === undefined) return { inicio: '', fin: '' };
  const now = new Date();
  const start = new Date();
  start.setDate(now.getDate() - days);
  return {
    inicio: toDateInputValue(start),
    fin: toDateInputValue(now)
  };
};

export const PRESETS = [
  { key: 'hoy', label: 'Hoy', days: 0 },
  { key: 'semana', label: 'Última semana', days: 7 },
  { key: 'mes', label: 'Último mes', days: 30 },
  { key: 'anio', label: 'Último año', days: 365 },
  { key: 'todo', label: 'Todo el historial', days: null }
];

export const renderOrigen = (origen) => {
  if (!origen) return <span style={{ color: '#94a3b8' }}>--</span>;
  const isPrincipal = origen === 'LOGIN_PRINCIPAL';
  return <span className={`ai-badge ${isPrincipal ? 'ai-badge-on' : 'ai-badge-soft'}`}>{isPrincipal ? 'Plataforma Web' : 'Portal Clientes'}</span>;
};

// Fecha de puesta en producción de la auditoría de ingresos: no existen registros anteriores.
export const FECHA_INICIO_AUDITORIA = '2026-10-07';

// Aviso persistente mientras el usuario está en el módulo; se cierra al salir para que no quede en otras pantallas.
export const useAvisoInicioAuditoria = () => {
  useEffect(() => {
    const [anio, mes, dia] = FECHA_INICIO_AUDITORIA.split('-');
    const fecha = `${dia}/${mes}/${anio}`;
    const id = toast({
      title: `Registros desde el ${fecha}`,
      description: `La auditoría de ingresos muestra únicamente los registros a partir del ${fecha}. No existen datos anteriores a esa fecha.`,
      type: 'neutral-blue',
      position: 'bottom-center',
      duration: 0
    });
    return () => dismissToast(id);
  }, []);
};



// WEBPACK FOOTER //
// ./src/components/configuracion/auditoriaIngresosComun.jsx